module.exports = __webpack_public_path__ + "/assets/bgr_drop_default.png";


/*****************
 ** WEBPACK FOOTER
 ** ../src/widgets/images/bgr_drop_default.png
 ** module id = 1467
 ** module chunks = 0
 **/